import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalAppsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalAppsSettings.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { getNavigationSidebarGlobalSettingsResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { forgeAdminSettingsRoute } from '@jira/router-routes__forge-routes/src/forgeAdminSettingsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ForgeAdminPage, { LazyForgeAdminPage } from './ui/admin/index.tsx';

export const forgeAdminSettingsRouteEntry: Route = createEntry(forgeAdminSettingsRoute, () => ({
	// eslint-disable-next-line no-restricted-syntax
	component: ForgeAdminPage,
	layout: globalSettingsLayout,

	navigation: {
		sidebarId: SidebarIdGlobalAppsSettings,
		menuId: MenuIdSettings,
	},

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarGlobalSettingsResources(),
		navigationSidebarGlobalResource,
	],

	forPaint: [LazyAtlassianNavigation, LazyForgeAdminPage],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
